// A scheduled MAR dose is "late" once more than this many minutes have passed since its scheduled time.
// Shared with the mobile app (spec 2026-10-08-mobile-nurse-design §7: "Late = more than 60 min after scheduled time").
export const LATE_DOSE_THRESHOLD_MINUTES = 60

/**
 * True when `now` is more than LATE_DOSE_THRESHOLD_MINUTES after `scheduledFor`.
 * Compares real instants (epoch milliseconds), so the browser's time zone never matters.
 */
export const isLateDose = (scheduledFor?: string | null, now: Date = new Date()): boolean => {
  if (!scheduledFor) return false

  const scheduledAt = new Date(scheduledFor).getTime()
  if (Number.isNaN(scheduledAt)) return false

  return now.getTime() - scheduledAt > LATE_DOSE_THRESHOLD_MINUTES * 60 * 1000
}
